import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedModule} from "../shared/shared.module";
import {UcetniJednotkaDataService} from "./ucetni-jednotka-data.service";
import {
  SestavenyVykazHlavickaDataService
} from "../data-services/sestaveny-vykaz-hlavicka/sestaveny-vykaz-data.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [
    { provide: UcetniJednotkaDataService, useClass: UcetniJednotkaDataService, multi: false },
    { provide: SestavenyVykazHlavickaDataService }
  ]
})
export class UcetniJednotkaDataModule { }
